var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 204 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 103,
    r: 66.5,
    stroke: "#8c82f2",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.922 163.757C164.529 162.364 162.273 162.364 160.88 163.757C159.487 165.15 159.487 167.406 160.88 168.799L168.443 176.362C169.139 177.058 170.052 177.407 170.964 177.407C171.876 177.407 172.789 177.059 173.485 176.362C174.878 174.969 174.878 172.713 173.485 171.32L165.922 163.757Z",
    fill: "#8c82f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.443 30.2591L160.88 37.8241C159.487 39.2171 159.487 41.4751 160.88 42.8661C161.576 43.5621 162.489 43.9111 163.401 43.9111C164.313 43.9111 165.226 43.5631 165.922 42.8661L173.485 35.3011C174.878 33.9081 174.878 31.6501 173.485 30.2591C172.092 28.8661 169.836 28.8661 168.443 30.2591Z",
    fill: "#8c82f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.626 188.793C99.6552 188.793 98.0602 190.39 98.0602 192.359V203.056C98.0602 205.025 99.6552 206.622 101.626 206.622C103.597 206.622 105.192 205.025 105.192 203.056V192.359C105.192 190.39 103.597 188.793 101.626 188.793Z",
    fill: "#8c82f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.686 99.7451H188.989C187.018 99.7451 185.423 101.342 185.423 103.311C185.423 105.28 187.018 106.877 188.989 106.877H199.686C201.657 106.877 203.252 105.28 203.252 103.311C203.252 101.342 201.656 99.7451 199.686 99.7451Z",
    fill: "#8c82f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3302 42.8661C38.0262 43.5621 38.9392 43.9111 39.8512 43.9111C40.7632 43.9111 41.6762 43.5631 42.3722 42.8661C43.7652 41.4751 43.7652 39.2171 42.3722 37.8241L34.8092 30.2591C33.4162 28.8661 31.1602 28.8661 29.7672 30.2591C28.3742 31.6501 28.3742 33.9081 29.7672 35.3011L37.3302 42.8661Z",
    fill: "#8c82f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3302 163.757L29.7672 171.32C28.3742 172.713 28.3742 174.969 29.7672 176.362C30.4632 177.058 31.3762 177.407 32.2882 177.407C33.2002 177.407 34.1132 177.059 34.8092 176.362L42.3722 168.799C43.7652 167.406 43.7652 165.15 42.3722 163.757C40.9792 162.364 38.7232 162.364 37.3302 163.757Z",
    fill: "#8c82f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.626 17.829C103.597 17.829 105.192 16.232 105.192 14.263V3.566C105.192 1.597 103.597 0 101.626 0C99.6552 0 98.0602 1.597 98.0602 3.566V14.263C98.0602 16.232 99.6552 17.829 101.626 17.829Z",
    fill: "#8c82f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2641 99.7451H3.56612C1.59512 99.7451 0.00012207 101.342 0.00012207 103.311C0.00012207 105.28 1.59512 106.877 3.56612 106.877H14.2631C16.2341 106.877 17.8291 105.28 17.8291 103.311C17.8291 101.342 16.2341 99.7451 14.2641 99.7451Z",
    fill: "#8c82f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.1a4f7df1.svg";
export { ForwardRef as ReactComponent };